<template>
  <Badge :severity="$enums.Severity.NEUTRAL" >Coming soon</Badge>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import Badge from '@/components/UIElements/Badge.vue';


@Options({
  components: {
    Badge
  },
})
export default class BadgeNoData extends Vue {

}
</script>

